import { Box, ITheme, Typography, useTheme } from '@mui/material';
import React from 'react';

export interface IPortfolioMenuItemProps{
    title: string;
    onClick: () => void;
    isActive: boolean;
}

const PortfolioMenuItem: React.FC<IPortfolioMenuItemProps> = ({ title, onClick, isActive}) => {
    const theme = useTheme() as ITheme;
    return <Box display={"flex"} flexBasis={"200px"} flexGrow={1} justifyContent={"center"}
            bgcolor={isActive ? theme.palette.primary.dark :theme.palette.common.white} boxShadow={"0px 2px 16px 0px #00000009"} padding={"17px 2px"} borderRadius={"8px"}
            sx={{ cursor: "pointer", userSelect: "none"}} onClick={onClick}>
        <Typography fontSize={"14px"} lineHeight={"17.07px"} fontWeight={"600"} textTransform={"uppercase"} color={isActive ? theme.palette.common.white : undefined}>{title}</Typography>
    </Box>
}

export default PortfolioMenuItem;